// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn__icon[data-v-2424d8dc]{cursor:pointer}.btn__attach-file>input[data-v-2424d8dc]{display:none}", ""]);
// Exports
module.exports = exports;
